package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_05_10_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes deep underground; they have solved the puzzles and riddles of Flar’Melkhis, a voice in their heads. As they descend a stairway heading South, they hear dripping and flowing water, and they smell salt water and the scent of decaying marine life. They see some human footprints. The tunnel opens up into an open space, perhaps a natural cavern.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes hear the voice of Flar’Melkhis once again, but this time the voice isn’t coming from inside their heads but rather from the cavern.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("You have entered the lair of Flar’Melkhis. Turn back now or parish!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Korvis conjures a Woodland Being, a hideous Sea Hag — Tuesday is shocked!. Korvis transforms into an air elemental. The heroes hear Flar’Melkhis again.")
    }
    com.varabyte.kobweb.compose.dom.GenericTag("blockquote") {
        org.jetbrains.compose.web.dom.P {
            org.jetbrains.compose.web.dom.Text("Welcome to your end; Children, finish them!")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see several Chuul scuttling towards them. Bigglesworth immediately sprints toward the enemies, leaving his comrades in the dust.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes see a humanoid on the southern rocks. Vernal, the Death Slaad jumps into the water.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("A giant wave grabs Korvis.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Flar’Melkhis, an Aboleth, rises from the water, and enslaves Bigglesworth.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Dusk, a humanoid, moves into the water. Caper shoots Dusk.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Vernal fireballs the heroes. Caper bravely takes the brunt of the fireball to save Falorn. Caper’s horns are smoking.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Fitzgeorge appears and casts Ice Storm.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Caper uses Calm Emotions on Bigglesworth, freeing him from the Aboleth’s enslavement.")
    }
}
